import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import { AssetOverviewPage } from '@/features/assets/components/AssetOverviewPage'
import { useAssetSummariesSuspense } from '@/features/assets/hooks/useAssetData'

export const Route = createFileRoute('/_authed/assets/')({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(
        convexQuery(api.assets.getInventory, {})
      ),
      context.queryClient.ensureQueryData(convexQuery(api.tasks.getTasks, {})),
      context.queryClient.ensureQueryData(
        convexQuery(api.setupQueue.getPendingItems, {})
      ),
    ])
  },
  pendingComponent: () => <LoadingScreen message="Loading assets..." />,
  component: AssetsRouteWrapper,
})

function AssetsRouteContent() {
  const { summaries } = useAssetSummariesSuspense()
  return <AssetOverviewPage summaries={summaries} />
}

function AssetsRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading assets..." />}>
      <AssetsRouteContent />
    </Suspense>
  )
}
